export default "<figure #graphFigure></figure>\r\n";